import React, { memo } from 'react';
import PropTypes from 'prop-types';

import StudyListTableRow, { TableData } from './StudyListTableRow';

export interface StudyListTableProps {
  tableDataSource?: TableData[];
  querying?: boolean;
  numOfStudies?: number;
  filtersMeta?: Record<string, any> | any[];
}

const StudyListTable: React.FC<StudyListTableProps> = ({
  tableDataSource = [],
  querying = false,
}) => {
  return (
    <div className="bg-black">
      <div className="relative">
        <table
          className="w-full text-white border-collapse overflow-hidden"
          aria-label="Study List"
        >
          <tbody
            data-cy="study-list-results"
            data-querying={querying}
          >
            {tableDataSource.map((tableData, index) => (
              <StudyListTableRow
                key={tableData?.reportId || index}
                tableData={tableData}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
  querying: PropTypes.bool,
  numOfStudies: PropTypes.number,
  filtersMeta: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const MemoizedStudyListTable = memo(StudyListTable);

export default MemoizedStudyListTable;
export { MemoizedStudyListTable as StudyListTable };
